export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8485.23b0db9e.jpg";